<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Quick Reply" class="d-icon d-icon--quick-reply" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M10 8.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 1 0-1h5A1.5 1.5 0 0 1 11 3.5v5A1.5 1.5 0 0 1 9.5 10H3.707l-1.853 1.854A.5.5 0 0 1 1 11.5V9a.5.5 0 1 1 1 0v1.293l1.147-1.146.076-.063A.5.5 0 0 1 3.5 9h6a.5.5 0 0 0 .5-.5ZM2.071 1.743a.5.5 0 0 1 .858.514L1.883 4H3a.501.501 0 0 1 .429.757l-1.5 2.5a.5.5 0 0 1-.858-.514L2.117 5H1a.5.5 0 0 1-.429-.757l1.5-2.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconQuickReply',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
